module.exports = __webpack_public_path__ + "media/driving_style_en_ipad_air.bb4e1c26.mp4";